<template>
    <!-- v-if="route.name !== 'celebration'" -->
    <div 
    v-if="route.name !== 'test'"
    
    class="fixed bottom-0 w-full bg-white py-3 md:py-4  flex flex-col justify-between items-center shadow-[0_-2px_6px_rgba(0,0,0,0.08)] z-20">

        <!-- brand icons row -->
        <div class="flex justify-center items-center gap-4 md:gap-6 lg:gap-8 w-full">

            <div class="flex justify-center items-center w-11 md:w-14 lg:w-16 aspect-square">
                <img class="w-full object-contain" src="cocacola-logo-Color.webp" alt="Coca Cola color">
            </div>

            <div class="flex justify-center items-center w-11 md:w-14 lg:w-16 aspect-square">
                <img class="w-full object-contain" src="fanta-logo.webp" alt="fanta">
            </div>

            <div class="flex justify-center items-center w-11 md:w-14 lg:w-16 aspect-square">
                <img class="w-full object-contain" src="schweppes-logo-color.webp" alt="schweppes">
            </div>

            <div class="flex justify-center items-center w-11 md:w-14 lg:w-16 aspect-square">
                <img class="w-full object-contain" src="uk_sprite_logo_green-text-only.webp" alt="sprite">
            </div>

        </div>

        <!-- Copyright -->
        <div class="text-xs font-medium md:text-sm text-gray-500 text-center mt-1">
            © 2025 The Coca-Cola Company
        </div>
    </div>
</template>

<script setup>
import { useRoute } from 'vue-router';


const route = useRoute();
</script>